import { Link } from "react-router-dom";

export const ProductCard = ({ product, index = 0 }) => (
  <Link
    to={`/library/${product.slug}`}
    data-testid={`product-card-${product.slug}`}
    className="group block"
  >
    <div className="overflow-hidden bg-brand-warm-white border border-brand-linen">
      <img
        src={product.cover}
        alt={product.title}
        className="w-full aspect-square object-cover group-hover:scale-[1.04] transition-transform duration-700 ease-out"
      />
    </div>
    <div className="pt-5">
      <span className="overline text-[0.62rem]">{product.category}</span>
      <h3 className="font-serif text-2xl mt-2 leading-snug group-hover:text-brand-olive transition-colors">{product.title}</h3>
      <p className="font-body text-sm text-brand-muted mt-1 italic">{product.subtitle}</p>
      <p className="font-sans text-sm text-brand-charcoal mt-3 tracking-wide">${product.price.toFixed(2)}</p>
    </div>
  </Link>
);
